<div [floatUi]="tooltipcontent"
  [showTrigger]="popperTrigger"
  [placement]="popperPlacement"
  [applyClass]="'popperSpecialStyle'"
  [positionFixed]=true>
  <ui-icon-button [title]="title" [color]="iconColor | iconButtonColorEnumPipe" [iconName]="'icon-info'" [heightInPx]="heightInPx" [widthInPx]="widthInPx" [screenReaderText]="screenReaderText" ></ui-icon-button>
</div>
<float-ui-content #tooltipcontent>
  @if (!isHtmlContent) {
    <span>{{screenReaderText}}</span>
  }
  @if (isHtmlContent) {
    <div [innerHTML]="screenReaderText"></div>
  }
</float-ui-content>

